/*
 * Copyright (c) Castle Point Learning Systems Corporation, 2013-2023, all rights reserved.
 * NOTICE: Dissemination of the information and/or materials contained in this file is strictly
 * forbidden unless prior written permission is obtained from Castle Point Learning Systems Corporation.
 * See LICENSE.txt (part of this package) for the full notice.
 */
export var Status;
(function (Status) {
    Status["ok"] = "ok";
    Status["error"] = "error";
    Status["warning"] = "warning";
    Status["hint"] = "hint";
})(Status || (Status = {}));
export var MathParameterType;
(function (MathParameterType) {
    MathParameterType["selection"] = "selection";
    MathParameterType["input"] = "input";
    MathParameterType["result"] = "result";
    MathParameterType["equivalentResult"] = "equivalentResult";
})(MathParameterType || (MathParameterType = {}));
export var MathSelectionType;
(function (MathSelectionType) {
    MathSelectionType["pd"] = "pd";
    MathSelectionType["comment"] = "comment";
    MathSelectionType["cell"] = "cell";
})(MathSelectionType || (MathSelectionType = {}));
export var MathSourceActionParameterElementType;
(function (MathSourceActionParameterElementType) {
    MathSourceActionParameterElementType["expression"] = "expression";
    MathSourceActionParameterElementType["tableProperties"] = "tableProperties";
    MathSourceActionParameterElementType["tablePoints"] = "tablePoints";
    MathSourceActionParameterElementType["graph"] = "graph";
    MathSourceActionParameterElementType["option"] = "option";
})(MathSourceActionParameterElementType || (MathSourceActionParameterElementType = {}));
export var MathEvaluationMeaningType;
(function (MathEvaluationMeaningType) {
    MathEvaluationMeaningType["rewrite"] = "rewrite";
    MathEvaluationMeaningType["transformation"] = "transformation";
})(MathEvaluationMeaningType || (MathEvaluationMeaningType = {}));
